module.exports = __webpack_public_path__ + "static/img/2.be82ff1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/2.jpg
// module id = ZWtP
// module chunks = 1